import { FC, useEffect, useState } from 'react';

import { FiX } from 'react-icons/fi';

import { useRouter } from 'next/router';

import { ScaleFade } from '@chakra-ui/react';

import { useClickOutside } from '~/shared/hooks/useClickOutside';
import { useAuth } from '~/modules/auth/hooks/useAuth';

import { Tooltip } from '~/shared/components/Tooltip';
import { Avatar } from '~/shared/components/Avatar';
import { Select } from '~/shared/components/Form/Select';
import { theme } from '~/shared/styles/theme';
import { Badge } from '~/shared/components/Badge';
import { Skeleton } from '~/shared/components/Skeleton';

import {
  Container,
  AvatarButton,
  PopoverContainer,
  ClosePopoverButton,
  PopoverContent,
} from './styles';

export const MyAccount: FC = () => {
  const router = useRouter();

  const {
    user,
    signOut,
    currentAccessId,
    setCurrentAccessId,
    currentAccessResale,
    accessOptions,
    isLoading,
  } = useAuth();

  const [isOpen, setIsOpen] = useState(false);

  function closePopover(): void {
    setIsOpen(false);
  }

  useEffect(() => {
    router.events.on('routeChangeStart', closePopover);

    return () => {
      router.events.off('routeChangeStart', closePopover);
    };
  }, [router]);

  const popoverRef = useClickOutside<HTMLLIElement>(closePopover);

  useEffect(() => {
    document.addEventListener('keydown', closePopover, false);

    return () => {
      document.removeEventListener('keydown', closePopover, false);
    };
  }, []);

  function tooglePopperIsOpen(): void {
    setIsOpen((prevState) => !prevState);
  }

  return (
    <Container ref={popoverRef}>
      <AvatarButton type="button" onClick={tooglePopperIsOpen}>
        <Avatar alt={user?.name} />
      </AvatarButton>

      <ScaleFade in={isOpen} initialScale={0.9} unmountOnExit>
        <PopoverContainer>
          <Tooltip label="Fechar">
            <ClosePopoverButton type="button" onClick={closePopover}>
              <FiX />
            </ClosePopoverButton>
          </Tooltip>

          <PopoverContent>
            <div>
              <Avatar alt={user?.name} size={60} iconSize={20} />
              {isLoading ? (
                <>
                  <Skeleton
                    width="120px"
                    height="14px"
                    marginTop={theme.spacing.sm}
                    marginBottom={theme.spacing.xs}
                  />
                  <Skeleton width="160px" height="14px" />
                </>
              ) : (
                <>
                  <strong>{user?.name}</strong>
                  <span>{user?.email}</span>
                </>
              )}

              {isLoading ? (
                <Skeleton
                  width="203px"
                  height="36px"
                  marginTop={theme.spacing.sm}
                  borderRadius={theme.borderRadius.sm}
                />
              ) : accessOptions?.length > 1 ? (
                <Select
                  name="accessId"
                  value={currentAccessId}
                  onChange={(value) => {
                    setCurrentAccessId(value as string);
                    router.reload();
                  }}
                  options={accessOptions}
                  size="sm"
                />
              ) : (
                currentAccessResale?.name && (
                  <Badge style={{ marginTop: theme.spacing.md }} breakRow>
                    {currentAccessResale?.code} - {currentAccessResale?.name}
                  </Badge>
                )
              )}
            </div>

            <button type="button" onClick={signOut}>
              Sair do portal
            </button>
          </PopoverContent>
        </PopoverContainer>
      </ScaleFade>
    </Container>
  );
};
